import { Flex } from "@mantine/core";

import { useDashboardNextPaymentDue } from "../../../api/hooks/collectionDashboard/useDashboardNextPaymentDue.ts";
import SectionTitle from "../../../components/Section/SectionTitle/SectionTitle.tsx";
import Table from "../../../components/Table/Table.tsx";
import { useStyles } from "../CollectionDashboardPage.styles.ts";
import { CollectionDashboardFilter } from "../types.ts";
import { useNextPaymentDueMonthTableData } from "./hooks/useNextPaymentDueMonthTableData.tsx";

interface NextPaymentDuePerMonthProps {
  filter: CollectionDashboardFilter;
}

const NextPaymentDuePerMonth = ({ filter }: NextPaymentDuePerMonthProps) => {
  const { classes } = useStyles();

  const [{ data, fetching }] = useDashboardNextPaymentDue(filter);

  const [columns, rows] = useNextPaymentDueMonthTableData({
    data: data?.dashboardNextPaymentDue,
  });

  return (
    <Flex direction="column" gap={12}>
      <SectionTitle variant="golden" flex={0} className={classes.sectionTitle}>
        Next Payment Due Per Month
      </SectionTitle>

      <Table
        columns={columns}
        rows={rows}
        minWidth={"100%"}
        loading={fetching}
      />
    </Flex>
  );
};

export default NextPaymentDuePerMonth;
